module.exports = __webpack_public_path__ + "img/martian-landscape-adjustedFinal.5d7553b3.jpg";